import React from 'react'
import Select from './Select';
import { useAction, useForm } from '../hooks';
import { useHistory} from 'react-router-dom';

const initFormSearchData = {
  sort_by: ''
}
const SortBy = () => {

  const getList = useAction('payment.getList')
  const [searchFormData] = useForm(initFormSearchData)
  const history = useHistory()
  
  const onChangeSelect = e => {
    initFormSearchData.sort_by = e.target.value;
    getList(searchFormData, () => {
      history.push({
        pathname: '/',
        search: `sort_by=${initFormSearchData.application_status}`
      })
    })
  }

  return (
    <div className="sort-by">
        <span className="label">Sort By</span>
        <div className="dropdown">
        <Select 
          options={[
            { value: 'asc', label: 'ASC' },
            { value: 'desc', label: 'DESC'}
          ]}
          onChange={onChangeSelect}
          value={initFormSearchData.sort_by}
        />
      </div>
    </div>
  )
}

export default SortBy